<template>
  <div class="settings__header-note">
    <SBIcon
      v-if="icon"
      :icon="icon"
      :color="SBColors.blackPrimary"
      :size="14"/>
    <div class="settings__header-note--main-section">
      <h2
        v-if="title"
        class="settings__header-note--title">{{ title }}</h2>
      <!-- No user input is rendered here. -->
      <!-- eslint-disable vue/no-v-html  -->
      <p
        v-if="text"
        class="settings__header-note--desc"
        v-html="text" />
      <!-- eslint-enable vue/no-v-html  -->

      <!-- No user input is rendered here. -->
      <!-- eslint-disable vue/no-v-html  -->
      <p
        v-if="sub"
        class="settings__header-note--sub"
        v-html="sub" />
      <!-- eslint-enable vue/no-v-html  -->
    </div>
  </div>
</template>
<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'SettingsNote',
  components: {
    SBIcon,
  },
  props: {
    icon: {
      type: Object,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    sub: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
};
</script>
